import apiService from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const state = {
  branches: [],
  selectedBranch: {},
  branchBookingDateRange: [],
};

const getters = {
  branches: (state) => state.branches,
  selectedBranch: (state) => state.selectedBranch,
  validSelectedBranch: (state) => {
    const branchIds = new Set(state.branches.map(branch => branch.id));
    return branchIds.has(state.selectedBranch.id);
  },
  branchCurrencySymbol: (state) => state.selectedBranch.currencySymbol,
  branchBookingDateRange: (state) => state.branchBookingDateRange,
};

const actions = {
  async getBranches({ commit, dispatch, state, getters }) {
    try {
      const response = await apiService.get(apiUrls.BRANCHES);
      commit("getBranches", response.data);
      if (
        // if never select branch before, will auto set the default branch to API 1st branch
        !state.selectedBranch.id ||
        // selectBranch id no longer valid - to handle unpublished branch case
        !getters.validSelectedBranch
      ) {
        dispatch("updateSelectedBranch", response.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getCustomerBranches({ commit }, customerId) {
    try {
      const response = await apiService.get(
        `${apiUrls.BRANCHES}?customerId=${customerId}`
      );
      commit("getCustomerBranches", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async updateSelectedBranch({ commit, state }, payload) {
    // compare the previous branch selection and current branch selection,
    // if it's not the same, will refetch current branch selection various data
    const isSameBranch = state.selectedBranch.id === payload.id;
    commit("updateSelectedBranch", payload);

    if (!isSameBranch) {
      store.dispatch("resetBranchData");

      // workaround: getPaymentMethods action depend on init state(getInit action), and init state may not initialize when getPaymentMethods action being dispatch
      await store.dispatch("getInit");

      const actions = [
        "getPaymentMethods",
        "getServices",
        "getPopularServices",
        "getPromotionServices",
        "getBranchBookingDateRange",
      ];
      await Promise.all(actions.map((action) => store.dispatch(action)));
    }
  },
  async getBranchBookingDateRange({ commit }) {
    try {
      const response = await apiService.get(
        `${apiUrls.BRANCH_BOOKING_DATE_RANGE}?branchId=${store.getters.selectedBranch.id}`
      );
      commit("getBranchBookingDateRange", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  resetBranchData() {
    store.dispatch("resetAppointmentHistory");
    store.dispatch("resetPurchaseHistory");
    store.dispatch("resetBookingList");
    store.dispatch("resetEstoreProducts");
    store.dispatch("resetEStorePaymentMethods");
    store.dispatch("resetCart");
  }
};

const mutations = {
  getBranches(state, payload) {
    state.branches = payload;
  },
  getCustomerBranches(state, payload) {
    state.branches = payload;
  },
  updateSelectedBranch: (state, payload) => {
    state.selectedBranch = payload;
  },
  getBranchBookingDateRange: (state, payload) => {
    state.branchBookingDateRange = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
